module.exports = "<div class=\"error tooltip hint pulse\"><%= message %></div>\n"